import _ from "underscore";

const initialState = {
    saved_sku_list: [],
    saved_searches: [],
    saved_search_items: [],
    saved_search_items_total: -1,
    search_id: null,
    user_profile: null,
    second_fa_token: null,
    second_fa_error: null,
    second_fa_expired: false,
    credit_summary: null,
    trade_in_details: null,
    show_sms_validation: false,
    sms_code_state: 0,
    toggle_cancel_order_modal: false,
    cancel_order_name: null,
    cancel_order_error: '',
    walletData: {
        details: null,
        total: null,
        errorMessage: null,
    },
    membershipData: {
        graphData: [],
        selectedSubscription: null,
        initialSubscriptionPlan: null,
        selectedContribution: null,
        requestError: null,
    },
    paymentMethods: {
        ach: [],
        check: [],
        sitecredit: [],
        wallet: [],
    },
    favoriteBankAccount: {},
    favoriteCheckAddress: {},
    pointsHistory: {
        pendingTransactions: [],
        completedTransactions: null,
    },
    cashHistory: {
        pendingTransactions: [],
        completedTransactions: null,
    },
    creditHistory: {
        pendingTransactions: [],
        completedTransactions: null,
    },
    rewardsHistory: {
        pendingTransactions: [],
        completedTransactions: null,
    },
    wallet2FAData: {
        token: null,
        errorMessage: null,
        screenType: 2,
        isVerified: false,
        blockedFor: "",
    },
    amountToCashModal: false,
    amountToCashLinkPath: '/',
    prev_purchases: [],
    prev_purchase: null,
    next_purchases_page: null,
    previous_purchases_page: null,
    submissions: [],
    submissionsDetailed: {},
    isFetchingSubmission: false,
    submissionOrderDetails: null,
    submissionOrderDetailsError: null,
    submissionProvideInfo: null,
    submissionProvideInfoError: null,
    submissionProvideInfoPhotoSet: null,
    evaluationphoto_set: [],
    prev_ticket_page: null,
    next_ticket_page: null,
    profileFavorites: [],
    consignments: {},
};

export default function myAccountReducer(state=initialState, action) {
    switch (action.type) {
        case 'SET_USER_PROFILE':
            return {
                ...state,
                user_profile: action.user
            }
        case 'SET_PROFILE_FAVORITES':
            return {
                ...state,
                profileFavorites: action.payload
            }
        case 'ADD_PROFILE_FAVORITES':
            return {
                ...state,
                profileFavorites: [...state.profileFavorites, action.payload]
            }
        case 'REMOVE_PROFILE_FAVORITES':
            return {
                ...state,
                profileFavorites: _.without(state.profileFavorites, action.payload)
            }
        case 'SKU_LIST':
            return {
                ...state,
                saved_sku_list: action.saved_sku_list
            }
        case 'SET_PREVIOUS_PURCHASES':
            return {
                ...state,
                prev_purchases: action.prev_purchases,
                next_purchases_page: action.next_purchases_page,
                previous_purchases_page: action.previous_purchases_page
            }
        case 'SET_SPECIFIC_PREVIOUS_PURCHASE':
            return {
                ...state,
                prev_purchase: action.payload,
            }
        case 'SAVED_SEARCHES':
            return {
                ...state,
                saved_searches: action.saved_searches,
            }
        case 'SET_SAVED_SEARCH_ITEMS':
            return {
                ...state,
                saved_search_items: action.products,
                saved_search_items_total: action.total_products,
                search_id: action.search_id,
                saved_search: action.saved_search
            }
        case 'ADD_SAVED_SEARCH':
            return {
                ...state,
                saved_searches: [...state.saved_searches, action.payload],
            }
        case 'SET_TRADE_INS':
            return {
                ...state,
                trade_ins: action.trade_ins
            }
        case 'SET_TRADE_IN_DETAILS':
            return {
                ...state,
                trade_in_details: action.trade_in_details
            }
        case 'RESET_TRADE_IN_DETAILS':
            return {
                ...state,
                trade_in_details: null
            }
        case 'SET_GIFT_TOTAL':
            return {
                ...state,
                user_gift_card_total: parseFloat(action.user_gift_card_total),
                user_gift_card_gfy_total: parseFloat(action.user_gift_card_gfy_total),
                use_rebag_credit_request_in_progress: false
            }
        case 'SET_2FA_TOKEN':
            return {
                ...state,
                second_fa_token: action.second_fa_token,
                second_fa_error: action.second_fa_error,
                second_fa_valid: action.second_fa_valid,
                second_fa_expired: false
            }
        case 'RESET_2FA_ERROR':
            return {
                ...state,
                second_fa_error: null
            }
        case 'SET_2FA_VALID':
            return {
                ...state,
                second_fa_valid: action.second_fa_valid,
                second_fa_error: action.second_fa_error,
            }
        case 'SET_2FA_EXPIRED':
            return {
                ...state,
                second_fa_error: null,
                second_fa_expired: true
            }
        case 'SET_CREDIT_LIST':
            return {
                ...state,
                credit_summary: action.credit_summary
            }
        case 'SET_REBAG_REWARDS':
            return {
                ...state,
                rebag_rewards: action.rebag_rewards
            }
        case 'SET_SMS_VALIDATION_CODE':
            return {
                ...state,
                show_sms_validation: true,
            }
        case 'SET_SMS_VALIDATION_CODE_ERROR':
            return {
                ...state,
                show_sms_validation: false,
            }
        case 'SET_SMS_CHECK_CODE':
            return {
                ...state,
                show_sms_validation: false,
                sms_code_state: action.sms_code_state,
                sms_code_state_message: action.sms_code_state_message
            }
        case 'TOGGLE_CANCEL_ORDER_MODAL':
            return {
                ...state,
                toggle_cancel_order_modal: action.toggle_cancel_order_modal,
                cancel_order_name: action.cancel_order_name,
                cancel_order_error: action.cancel_order_error,
            }
        case 'SET_WALLET_DETAILS':
            return { ...state, walletData: action.payload }
        case 'SET_PAYMENT_METHODS':
            return { ...state, paymentMethods: action.payload }
        case 'SET_FAVORITE_BANK_ACCOUNT':
            return { ...state, favoriteBankAccount: action.payload }
        case 'SET_FAVORITE_CHECK_ADDRESS':
            return { ...state, favoriteCheckAddress: action.payload }
        case 'SET_POINTS_TRANSACTION_HISTORY':
            return { ...state, pointsHistory: action.payload}
        case 'SET_CASH_TRANSACTION_HISTORY':
            return { ...state, cashHistory: action.payload}
        case 'SET_CREDIT_TRANSACTION_HISTORY':
            return { ...state, creditHistory: action.payload}
        case 'SET_WALLET_ERROR':
            return {...state, walletData: {...state.walletData, errorMessage: action.payload}}
        case 'SET_WALLET_2FA_TOKEN':
            return { ...state, wallet2FAData: {...state.wallet2FAData, token: action.payload}}
        case 'SET_WALLET_2FA_VERIFIED':
            return { ...state, wallet2FAData: {...state.wallet2FAData, isVerified: action.payload}}
        case 'SET_WALLET_2FA_ERROR':
            return {...state, wallet2FAData: {...state.wallet2FAData, errorMessage: action.payload}}
        case 'SET_WALLET_2FA_SCREEN_TYPE':
            return {...state, wallet2FAData: {...state.wallet2FAData, screenType: action.payload}}
        case 'SET_WALLET_2FA_BLOCKED_FOR':
            return {...state, wallet2FAData: {...state.wallet2FAData, blockedFor: action.payload}}
        case 'SET_WALLET_AMOUNT_TO_CASH':
            return {...state, user_profile: {...state.user_profile, walletCashOut: action.payload}}
        case 'SET_WALLET_AMOUNT_TO_CASH_MODAL':
            return {...state, amountToCashModal: action.payload}
        case 'SET_WALLET_AMOUNT_TO_CASH_LINK_PATH':
            return {...state, amountToCashLinkPath: action.payload}
        case 'SET_SUBMISSIONS':
            return {...state, submissions: action.payload, prev_ticket_page: action.prev_ticket_page, next_ticket_page: action.next_ticket_page}
        case 'SET_SUBMISSIONS_DETAILED':
            return {...state, submissionsDetailed: {...state.submissionsDetailed, [action.payloadId]: action.payload}}
        case 'SET_SUBMISSION_ORDER_DETAILED':
            return {...state, submissionOrderDetails: action.payload}
        case 'SET_SUBMISSION_ORDER_DETAILED_ERROR':
            return {...state, submissionOrderDetailsError: action.payload}
        case 'SET_SUBMISSIONS_PROVIDE_INFO':
            return {...state, submissionProvideInfo: action.payload}
        case 'SET_SUBMISSIONS_PROVIDE_INFO_PHOTOS':
            return {...state, submissionProvideInfoPhotoSet: action.payload}
        case 'SET_SUBMISSIONS_PROVIDE_INFO_ERROR':
            return {...state, submissionProvideInfoError: action.payload}
        case 'SET_SUBMISSIONS_PROVIDE_INFO_HERMES_LEATHER':
            return {...state, submissionProvideInfoHermesLeather: action.payload}
        case 'SET_SUBMISSIONS_PROVIDE_INFO_HERMES_SIZES':
            return {...state, submissionProvideInfoHermesSizes: action.payload}
        case 'SHOW_SUBMISSION_SPINNER':
            return {...state, isFetchingSubmission: true}
        case 'HIDE_SUBMISSION_SPINNER':
            return {...state, isFetchingSubmission: false}
        case 'SET_EVALUATION_PHOTO_SET':
            return {...state, evaluationphoto_set: [...state.evaluationphoto_set, action.payload]}
        case 'RESET_EVALUATION_PHOTO_SET':
            return {...state, evaluationphoto_set: []}
        case 'SET_CONSIGNMENTS':
            return {...state, consignments: action.payload}
        case 'SET_MEMBERSHIP_DATA_ERROR':
            return {...state, membershipData: {...state.membershipData, requestError: action.payload}}
        case 'SET_MEMBERSHIP_GRAPH_DATA':
            return {...state, membershipData: {...state.membershipData, graphData: action.payload}}
        case 'SET_MEMBERSHIP_SELECTED_SUBSCRIPTION':
            return {...state, membershipData: {...state.membershipData, selectedSubscription: action.payload}}
        case 'SET_MEMBERSHIP_PERIOD':
            return {...state, membershipData: {...state.membershipData, membershipPeriod: action.payload}}
        case 'SET_MEMBERSHIP_INITIAL_SUBSCRIPTION_PLAN':
            return {...state, membershipData: {...state.membershipData, initialSubscriptionPlan: action.payload}}
        case 'SET_REWARDS_TRANSACTION_HISTORY':
            return { ...state, rewardsHistory: action.payload}
        case 'SET_SELECTED_CONTRIBUTION':
            return {...state, membershipData: {...state.membershipData, selectedContribution: action.payload}}
        default:
            return state;
    }
};